import { useEffect, useState, useCallback } from 'react';
import { objectToCamel } from 'ts-case-convert';

import { getPrice, Price } from '@/shared/api/borrow';

export const useFetchPrice = (base: string, quote: string) => {
    const [data, setData] = useState<Price | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const fetchPrice = useCallback(async () => {
        try {
            const response = await getPrice(base, quote);
            const result = objectToCamel(response);
            setData(result);
        } catch (err) {
            setError((err as Error).message);
        } finally {
            setLoading(false);
        }
    }, [base, quote]);

    useEffect(() => {
        fetchPrice();
    }, [fetchPrice]);

    return {
        data,
        error,
        loading,
    };
};
